import React from 'react'
import { ReactComponent as Logo } from "../../Assets/Images/logo.svg";

const Header = () => {
  return (
    <>
      <header>
        <div className="d-flex justify-content-center logo-sp">
          <Logo />
        </div>
      </header>
    </>
  )
}

export default Header